
































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import BaseCurrency from "@/components/Base/Controls/BaseCurrency.vue";
import PreliminaryReportModel from "@/model/PreliminaryReport";

const AppStore = namespace("App");
const FormStore = namespace("Form");

@Component({
  components: {
    BaseCurrency
  }
})
export default class PreliminaryReportHCP extends Vue {
  @Prop({ required: true })
  readonly value!: PreliminaryReportModel;

  private report: PreliminaryReportModel | null = this.value;

  @AppStore.State
  public reportYear!: number;

  @FormStore.State
  formDisabled!: boolean;

  @Watch("value") setValue(newValue: PreliminaryReportModel) {
    this.report = newValue;
  }

  created() {
    this.report = this.value;
  }

  touch(validator: any) {
    validator && validator.$touch && validator.$touch();
  }
}
